'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _UISimpleAvatar = require('./UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _Constants = require('./Constants');

var _MD = require('./lib/MD5');

var _MD2 = _interopRequireDefault(_MD);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'UIUnauthedHubSpotUserAvatar',

  propTypes: {
    className: _react.PropTypes.string,
    shape: _UISimpleAvatar2.default.propTypes.shape,
    size: _UISimpleAvatar2.default.propTypes.size,
    email: _react.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: 'sm',
      shape: 'circle'
    };
  },
  getHubSettingsUrl: function getHubSettingsUrl() {
    var _props = this.props,
        email = _props.email,
        size = _props.size;

    if (typeof email === 'undefined') {
      return _Constants.DEFAULT_AVATAR_MAPPINGS.hubSpotUserEmail;
    }

    var env = _enviro2.default.getInternal('api') === 'qa' ? 'qa' : '';
    var emailHash = (0, _MD2.default)(email.toLowerCase());

    var sizePx = _Constants.AVATAR_SIZES[size];
    var doubleDimensionForRetina = sizePx * _Constants.RETINA_MULTIPLIER;

    return 'https://app.hubspot' + env + '.com/hubsettings/v1/avatar/hash/' + emailHash + '/' + doubleDimensionForRetina;
  },
  render: function render() {
    return _react2.default.createElement(_UISimpleAvatar2.default, _extends({}, this.props, { src: this.getHubSettingsUrl() }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-1.1732/js/UIUnauthedHubSpotUserAvatar.js
// module id = 391
// module chunks = 0